import React from 'react'
import PrizesBody from './PrizesBody'
import { boxPrizesSept2026 } from '../../../constants/copyright'

const PrizesBoxes = React.forwardRef(function PrizesBoxes({ isGamesRatingPrizes }, ref) {
  return (
    <PrizesBody
      currentPrizes={boxPrizesSept2026}
      isGamesRatingPrizes={isGamesRatingPrizes}
      mod={'static-box'}
    />
  )
})
export default PrizesBoxes
PrizesBoxes.propTypes = {}
